<template>
  <div class="big">
    <div class="page_title">医生线下挂号记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span class="itemtitle">患者姓名</span>
            <el-input v-model="user_name"
                      style="width: 160px"
                      @change="search"
                      clearable></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input v-model="doctor_name"
                      style="width: 160px"
                      @change="search"
                      clearable></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医生手机</span>
            <el-input v-model="doctor_phone"
                      style="width: 160px"
                      @change="search"
                      clearable></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">挂号状态</span>
            <el-select v-model="status"
                       placeholder="请选择"
                       style="width: 160px"
                       @change="search">
              <el-option v-for="item in status_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">挂号时间</span>
            <el-date-picker v-model="date"
                            type="daterange"
                            range-separator="~"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            style="width: 225px;"
                            @change="search"></el-date-picker>
          </div>
          <div class="item">
            <span class="itemtitle">看诊时间</span>
            <el-date-picker v-model="register_date"
                            type="daterange"
                            range-separator="~"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            style="width: 225px;margin-right:10px"
                            @change="search"></el-date-picker>
            <el-button type="info"
                       style="background-color: #eceff2; color: #747981"
                       @click="search">查询</el-button>
            <el-button plain
                       style="background-color: #eceff2; color: #747981"
                       @click="reSet">重置</el-button>
          </div>

        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column prop="order_sn"
                             label="预约单号"></el-table-column>
            <el-table-column prop="create_time"
                             label="挂号时间"
                             width="100"></el-table-column>
            <el-table-column label="患者信息">
              <template slot-scope="scope">
                <div>
                  {{scope.row.user_name}}
                </div>
                <div>
                  <span v-if="scope.row.sex==1">男</span>
                  <span v-if="scope.row.sex==2">女</span>
                  <span style="margin-left:10px">{{scope.row.age}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div>
                  <span style="margin-right:10px">{{scope.row.doctor_name}}</span>
                  <span v-if="scope.row.doctor_sex==1">男</span>
                  <span v-if="scope.row.doctor_sex==2">女</span>
                </div>
                <div>
                  {{scope.row.phone}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="department_name"
                             label="科室"></el-table-column>
            <el-table-column prop="hospital"
                             label="坐诊地点名称"></el-table-column>
            <el-table-column prop="register_time"
                             label="看诊时段"
                             width="140">
              <template slot-scope="scope">
                <div>{{scope.row.register_time}}</div>
                <span style="margin-right:5px"
                      v-if="scope.row.end_time && scope.row.day_time != 0">{{scope.row.end_time}}</span>
                <span v-if="scope.row.day_type==1">上午</span>
                <span v-if="scope.row.day_type==2">下午</span>
                <span v-if="scope.row.day_type==4">晚上</span>
              </template>
            </el-table-column>
            <el-table-column prop="week_name"
                             label="周号"
                             width="80"></el-table-column>
            <el-table-column label="挂号状态"
                             prop="status_str">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.operation==1"
                           @click="toCancelDia(scope.row)"
                           type="text"
                           size="medium"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('1096') : false
                  ">取消</el-button>
                <el-button v-if="scope.row.operation==2"
                           @click="signSchedulingRegister(scope.row)"
                           type="text"
                           size="medium"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('1098') : false
                  ">标记未就诊</el-button>
                <el-button v-if="scope.row.operation==3"
                           @click="toCancelReason(scope.row)"
                           type="text"
                           size="medium"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('1099') : false
                  ">查看取消原因</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin:20px 0"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 取消弹窗 -->
    <el-dialog title="取消"
               :visible.sync="cancelDia"
               width="440px"
               :close-on-click-modal="false">
      <div class="diabox">
        <div style="color:#FF3200">
          请您再次核查，确认取消患者{{cancelData.user_name}}的{{cancelData.register_time}}的挂号!
        </div>
        <div style="margin:20px 0">
          <span class="diaTitle">取消原因：</span>
          <el-select v-model="cancelData.cancel_desc"
                     placeholder="请选择"
                     style="width:300px">
            <el-option v-for="item in reasonList"
                       :key="item.title"
                       :label="item.title"
                       :value="item.title">
            </el-option>
          </el-select>
        </div>
        <div class="flex">
          <span class="diaTitle">备注：</span>
          <el-input type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="cancelData.remark"
                    style="width:300px"
                    maxlength="200">
          </el-input>
        </div>
      </div>
      <div style="text-align: center;padding:20px 0">
        <span slot="footer"
              class="dialog-footer">
          <el-button plain
                     @click="cancelDia=false"
                     size="medium">取消</el-button>
          <el-button type="primary"
                     @click="submitCancel"
                     size="medium">确定</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 查看取消原因 -->
    <el-dialog title="查看取消原因"
               :visible.sync="cancelReason"
               width="450px"
               :close-on-click-modal="false">
      <div class="diabox">
        <div>
          <span class="diaTitle">取消方：</span>
          <span v-if="cancelData.cancel_from==1">患者</span>
          <span v-if="cancelData.cancel_from==2">平台</span>
        </div>
        <div style="margin:16px 0">
          <span class="diaTitle">取消时间：</span>
          <span>{{cancelData.cancel_time}}</span>
        </div>
        <div style="margin:16px 0">
          <span class="diaTitle">取消原因：</span>
          <span>{{cancelData.cancel_desc}}</span>
        </div>
        <div class="flex">
          <span class="diaTitle">备注：</span>
          <span class="remark">{{cancelData.remark}}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      user_name: '',
      doctor_name: '',
      doctor_phone: '',
      date: [],
      register_date: [],
      status: 0,
      status_list: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '待就诊',
          value: 1
        },
        {
          label: '未就诊',
          value: 2
        },
        {
          label: '已退号',
          value: 3
        },
        {
          label: '已完成',
          value: 4
        }
      ],
      cancelDia: false,
      cancelReason: false,
      cancelData: {
        register_id: '',
        cancel_desc: '',
        remark: '',
        cancel_from: 1,
        cancel_time: ''
      },
      reasonList: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取原因列表
    getReasonList() {
      this.axios.post('platform/doctor/getCancellationReason').then((res) => {
        if (res.code == 0) {
          this.reasonList = res.data;
        }
      });
    },
    //获取用户列表
    getList() {
      let data = {
        user_name: this.user_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        status: this.status,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      if (this.register_date && this.register_date.length > 0) {
        data.register_time_start = dayjs(this.register_date[0]).format(
          'YYYY-MM-DD'
        );
        data.register_time_end = dayjs(this.register_date[1]).format(
          'YYYY-MM-DD'
        );
      }
      this.axios
        .post('platform/doctor/schedulingRegisterLists', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm:ss');
              item.register_time = dayjs
                .unix(item.register_time)
                .format('YYYY-MM-DD');
              item.end_time = item.end_time
                ? dayjs.unix(item.end_time).format('HH:mm')
                : '';
              item.week_name = '周' + '日一二三四五六'.charAt(item.week);
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //搜索重置
    reSet() {
      this.user_name = '';
      this.doctor_name = '';
      this.doctor_phone = '';
      this.status = 0;
      this.register_date = [];
      this.date = [];
      this.getList();
    },
    //查看取消原因
    toCancelReason(row) {
      this.cancelData = {
        register_id: row.register_id,
        cancel_desc: row.cancel_desc,
        remark: row.remark,
        cancel_from: row.cancel_from,
        cancel_time: dayjs.unix(row.cancel_time).format('YYYY-MM-DD HH:mm:ss')
      };
      this.cancelReason = true;
    },
    //取消弹窗
    toCancelDia(row) {
      this.cancelData = {
        register_id: row.register_id,
        cancel_desc: '',
        remark: '',
        user_name: row.user_name,
        register_time: row.register_time
      };
      this.cancelDia = true;
    },
    //取消提交
    submitCancel() {
      if (!this.cancelData.cancel_desc) {
        this.$message.error('请选择取消原因');
        return false;
      }
      let data = this.cancelData;
      this.axios
        .post('platform/doctor/cancelSchedulingRegister', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.cancelDia = false;
            this.getList();
          }
        });
    },
    //标记未就诊
    signSchedulingRegister(row) {
      this.$confirm(
        `请您再次核查，确认标记患者${row.user_name}的挂号未就诊？确认后状态更新为未就诊`,
        '确认取消',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          let register_id = row.register_id;
          this.axios
            .post('platform/doctor/signSchedulingRegister', { register_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('标记成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
    this.getReasonList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 20px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      width: 60px;
      text-align: right;
      margin-right: 10px;
    }
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.diabox {
  width: 500px;
  padding: 20px;
  text-align: left;
  .diaTitle {
    display: inline-block;
    width: 80px;
    text-align: right;
  }
  .remark {
    display: inline-block;
    width: 300px;
  }
}
</style>